import CryptoJS from 'crypto-js'; // npm install crypto-js
import Cookies from 'js-cookie';

// Get the encryption key from environment variables
const ENCRYPTION_KEY = import.meta.env.VITE_PUBLIC_ENCRYPTION_KEY;

// Check if running in Electron
const isElectron = () => {
  return typeof window !== 'undefined' && window.IS_ELECTRON === true;
};

// Encrypt data
export const encrypt = (data) => {
  if (!data) return null;
  try {
    return CryptoJS.AES.encrypt(String(data), ENCRYPTION_KEY).toString();
  } catch (error) {
    console.error('Encryption failed:', error);
    return null;
  }
};

// Decrypt data
export const decrypt = (encryptedData) => {
  if (!encryptedData) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};

// Secure storage implementation for localStorage
const secureLocalStorage = {
  setItem: (key, value) => {
    const encryptedValue = encrypt(String(value));
    localStorage.setItem(key, encryptedValue);
  },
  
  getItem: (key) => {
    const encryptedValue = localStorage.getItem(key);
    return decrypt(encryptedValue);
  },
  
  removeItem: (key) => {
    localStorage.removeItem(key);
  }
};

// Secure storage implementation for cookies
const secureCookieStorage = {
  setItem: (key, value, options = {}) => {
    const encryptedValue = encrypt(String(value));
    Cookies.set(key, encryptedValue, {
      expires: 7,
      secure: true,
      sameSite: 'strict',
      ...options
    });
  },
  
  getItem: (key) => {
    const encryptedValue = Cookies.get(key);
    return decrypt(encryptedValue);
  },
  
  removeItem: (key) => {
    Cookies.remove(key);
  }
};

// Get the appropriate storage based on environment
export const secureStorage = isElectron() ? secureLocalStorage : secureCookieStorage;

// Redux-persist compatible storage implementation
export const reduxPersistStorage = {
  getItem: (key) => {
    return new Promise((resolve) => {
      const value = secureStorage.getItem(key);
      resolve(value);
    });
  },
  
  setItem: (key, value) => {
    return new Promise((resolve) => {
      secureStorage.setItem(key, value);
      resolve();
    });
  },
  
  removeItem: (key) => {
    return new Promise((resolve) => {
      secureStorage.removeItem(key);
      resolve();
    });
  }
};

export default secureStorage;